import axios from 'axios';
import http from 'http';
import https from 'https';

import LocalDataManager from '../managers/LocalDataManager';

export default class WebApiService {

    constructor() {

        this.host = window.__globalConfig.baseUrl
        this.dbm = new LocalDataManager();

        this.checkRefreshToken = this.checkRefreshToken.bind(this);
    }

    checkRefreshToken(auth, callback, errorCallback) {

        let self = this;

        if(zzDataCache.auth != null){
            let authDate = new Date(zzDataCache.auth.expires)
            let nowDate = new Date()

            if (authDate - nowDate <= 0) {

                window.axiosInstance.defaults.headers.Authorization = auth.tokenType + ' ' + auth.accessToken;
                window.axiosInstance
                    .post(self.host + "/Token", "grant_type=refresh_token&client_id=web&refresh_token=" + auth.refreshToken)
                    .then(function (res) {

                        auth.accessToken = res.data.access_token;
                        auth.refreshToken = res.data.refresh_token;
                        auth.issued = res.data[".issued"];
                        auth.expires = res.data[".expires"];
                        auth.expiresIn = res.data.expires_in;

                        zzDataCache.auth = auth;
                        window.localStorage.setItem('zzAuth', JSON.stringify(auth));

                        callback(auth);

                    }, function (err) {
                        window.logout();
                        //errorCallback(err);
                    })
            } else {
                callback(auth);
            }
        }
    }

    post(uri, packet, success, error) {
        var self = this;

        this.dbm.getAuthInfo().then(
            tmpAuth => {
                if (tmpAuth != undefined && tmpAuth != null) {
                    this.checkRefreshToken(tmpAuth,
                        auth => {
                            window.axiosInstance.defaults.headers.Authorization = auth.tokenType + ' ' + auth.accessToken;
                            window.axiosInstance
                                .post(self.host + uri, packet, (self.host.includes("https://") ? { httpsAgent: self.httpsAgent } : { httpAgent: self.httpAgent }))
                                .then(function (res) {
                                    if (success != undefined) {
                                        success(res.data,res.headers);
                                    }
                                }, function (err) {
                                    if (error != undefined) {
                                        error(err);
                                    }
                                })
                        },
                        err => {
                            if (error != undefined) {
                                error(err);
                            }
                        }
                    );
                }
            }
        );
    }

    

    get(uri, success, error) {
        var self = this;

        this.dbm.getAuthInfo().then(
            tmpAuth => {
                if (tmpAuth != undefined && tmpAuth != null) {
                    this.checkRefreshToken(tmpAuth,
                        auth => {
                            window.axiosInstance.defaults.headers.Authorization = auth.tokenType + ' ' + auth.accessToken;
                            window.axiosInstance
                                .get(self.host + uri, (self.host.includes("https://") ? { httpsAgent: self.httpsAgent } : { httpAgent: self.httpAgent }))
                                .then((res) => {
                                    if (success != undefined) {
                                        success(res.data);
                                    }
                                }, (err) => {

                                    if (error != undefined) {
                                        error(err);
                                    }
                                });
                        },
                        err => {
                            if (error != undefined) {
                                error(err);
                            }
                        }
                    );
                }
            }
        );
    }

    postAnon(uri, packet, success, error) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .post(self.host + uri, packet)
            .then((res) => {
                if (success != undefined) {
                    success(res.data);
                }
            }, (err) => {
                if (error != undefined) {
                    error(err);
                }
            });
    }

    getAnon(uri, success, error) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .get(self.host + uri)
            .then((res) => {
                if (success != undefined) {
                    success(res.data);
                }
            }, (err) => {
                if (error != undefined) {
                    error(err);
                }
            });
    }

    postExternal(url, packet, success, error) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .post(url, packet)
            .then((res) => {
                if (success != undefined) {
                    success(res.data);
                }
            }, (err) => {

            })
            .catch((err) => {
                if (error != undefined) {
                    error(err);
                }
                else {

                }
            });
    }

    getExternal(url, success, error) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .get(url)
            .then((res) => {
                if (success != undefined) {
                    success(res.data);
                }
            }, (err) => {

            })
            .catch((err) => {
                if (error != undefined) {
                    error(err);
                }
                else {

                }
            });

    }
}